import React, { useState, useEffect, useRef } from 'react';
import { Paper, Typography, Box, Skeleton } from '@mui/material';

const AnimatedCounter = ({ endValue }) => {
  const [count, setCount] = useState(0);
  const prevValue = useRef(0);

  useEffect(() => {
    let start = prevValue.current;
    const end = parseInt(endValue) || 0;
    const duration = 800; 
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const current = Math.floor(progress * (end - start) + start);
      setCount(current);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        prevValue.current = end;
      }
    };
    window.requestAnimationFrame(step);
  }, [endValue]);

  return <>{count.toLocaleString()}</>;
};

const StatCard = ({ title, value, color, loading }) => (
  <Paper 
    elevation={0}
    className="flex-1 min-w-[140px] px-4 py-2.5 rounded-md relative transition-all duration-200"
    sx={{ 
      background: '#0f172a',
      border: `1px solid ${color}40`,
      '&:hover': { border: `1px solid ${color}`, transform: 'translateY(-2px)' }
    }}
  >
    <Typography 
      className="font-bold uppercase tracking-[0.1em] text-[9px] mb-0.5"
      sx={{ color: color, opacity: 0.9 }}
    >
      {title}
    </Typography>
    
    <Typography 
      variant="h5" 
      className="font-black tabular-nums tracking-tight"
      sx={{ color: '#f8fafc' }}
    >
      {loading ? (
        <Skeleton variant="text" width="60%" sx={{ bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
      ) : (
        <AnimatedCounter endValue={value} />
      )}
    </Typography>

    <Box 
      className="absolute top-0 right-0 w-8 h-full opacity-20"
      sx={{ 
        background: `linear-gradient(to left, ${color}, transparent)`,
        filter: 'blur(15px)' 
      }}
    />
  </Paper>
);

const CollectionReportAnalysis = ({ totalQuotation, totalCollection, totalUser, totalClient, totalQty, loading }) => {
  const stats = [
    { title: "Quotations", value: totalQuotation, color: "#38bdf8" },
    { title: "Collections", value: totalCollection, color: "#a78bfa" },
    { title: "Users", value: totalUser, color: "#4ade80" },
    { title: "Clients", value: totalClient, color: "#fbbf24" },
    { title: "Quantity", value: totalQty, color: "#f87171" },
  ];

  return (
    <Box className="w-full flex flex-wrap items-center gap-3 mb-4">
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} loading={loading} />
      ))}
    </Box>
  );
};

export default CollectionReportAnalysis;
